import React from "react"
import { Link } from "gatsby"
import Img from "gatsby-image"

const RecentWeddingDayStories = ({ imageData }) => {
  return (
    <React.Fragment>
      <div className="bg-dark py-5">
        <div className="container ">
          <div className="d-flex justify-content-between flex-column flex-md-row">
            <div className="text-white text-center text-md-left">
              <h2>Recent Wedding Day Stories</h2>
              <p className="text-muted">
                See selected images from recent wedding days
              </p>
            </div>
            <div className="text-center text-md-right">
              <Link to="/blog">
                <button className="btn btn-outline-light" type="button">
                  View The Wedding Blog
                </button>
              </Link>
            </div>
          </div>
          <div className="row mt-5 mt-md-2">
            {imageData.map(image => {
              return (
                <div
                  key={image.node.id}
                  className="col-12 col-md-6 col-lg-3 mt-4 mt-lg-0"
                >
                  <Img
                    style={{ height: "20rem" }}
                    fluid={image.node.childImageSharp.fluid}
                  />
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

export default RecentWeddingDayStories
